export const AND_SEPARATOR = ' AND ';
export const CATEGORY_SEARCH_QUERY_PREFIX = 'category:';
export const DEBOUNCE_DELAY_MS = 150;
export const HIGHLIGHT_REGEX = /[\ue000\ue001]/g;
export const IS_CATEGORY_QUERY_REGEX = /(category:)/gi;
export const IS_TO_OR_FROM_QUERY_REGEX = /((To:)|(From:))/gi;
export const MAX_CATEGORY_SUGGESTIONS_TO_SHOW = 1;
export const MAX_FILE_SUGGESTIONS_TO_SHOW = 2;
export const MAX_HISTORY_ENTRIES = 100;
export const MAX_SERVER_SUGGESTION_OF_KIND = 3;
export const MAX_WEB_SEARCH_SUGGESTIONS_TO_SHOW = 1;
export const MAX_SETTING_SUGGESTIONS_TO_SHOW = 1;
export const OR_SEPARATOR = ' OR ';
export const QUERY_LENGTH_FOR_CONFIDENCE = 3;
export const SPACE = ' ';
export const TO_PREFIX = 'To:{0}';
export const FROM_PREFIX = 'From:{0}';
export const CC_PREFIX = 'CC:{0}';
export const PARENTHESIS_FORMAT_STRING = '({0})';
export const ADVANCED_SEARCH_BREAKPOINT = 460;
export const FILTERS_BUTTON_ID = 'filtersButtonId';
export const MAX_TRY_SUGGESTIONS_TO_SHOW = 2;
export const TRY_SUGGESTION_DISPLAY_COUNT_STRING = 'trySuggestionsDisplayCount';
export const TRY_SUGGESTION_CLICK_COUNT_STRING = 'trySuggestionsClickCount';
export const TRY_SUGGESTION_IDS_STRING = 'trySuggestionIds';
export const TRY_SUGGESTION_FIRST_SHOWN = 'trySuggestionFirstShown';
export const ALLOWED_SETTING_SUGGESTIONS_KEYS = [
    'darkMode',
    'signature',
    'calendarApperance_boldColors',
    'automaticRepliesOption',
    'inboxRules',
    'weatherOption',
    'appearance',
    'focused',
    'regional',
    'messageFormat',
    'browserNotifications',
    'forwardingOption',
    'hoverSurfaceActions',
    'conversations',
    'birthdayCalendar',
    'theme',
    'blockedSendersAndDomainsV2',
    'safeSendersDomainsV2',
    'readingPane',
    'calendarSurfaceAddins',
];
